import type { PortalNavItem } from '@/types';
import styles from './Footer.module.css';

interface FooterProps {
  privacyPolicy: PortalNavItem['privacyPolicy'];
  accessibilityStmt: PortalNavItem['accessibilityStmt'];
  termsOfUse: PortalNavItem['termsOfUse'];
}

export function Footer({ privacyPolicy, accessibilityStmt, termsOfUse }: FooterProps) {
  const year = new Date().getFullYear();
  const accessibilityHref = accessibilityStmt?.trim() || '#';

  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={`container ${styles.inner}`}>
        <p className={styles.accessibility}>
          <a href={accessibilityHref} target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
            Accessibility Statement
          </a>
        </p>
        <p className={styles.copyright}>
          &copy; {year} Optum, all rights reserved. Use of this site constitutes acceptance of Optum{' '}
          <a href={termsOfUse} target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
            Terms of Services
          </a>
          {' '}and{' '}
          <a href={privacyPolicy} target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
            Privacy Policy
          </a>
          .
        </p>
      </div>
    </footer>
  );
}

